import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { TableScroll } from '@hp/ui';
import type { MergeJob } from './queries';
import { EntityBadge, ModeBadge, StatusBadge } from '../../components/badges';
import { RelativeTime } from '../../components/relative-time';
import { BrutTable, BrutTheadRow } from '../../components/ui/table';
import { prettyJson, statsSummary } from '../../lib/format';

export function JobTable({ jobs, isLoading }: { jobs: MergeJob[]; isLoading: boolean }) {
  const { t } = useTranslation(['jobs', 'common']);
  const navigate = useNavigate();
  return (
    <section className="hp-card">
      <TableScroll label={t('table.label')}>
        <BrutTable>
          <BrutTheadRow>
            <th>{t('common:table.id')}</th>
            <th>{t('common:table.mode')}</th>
            <th>{t('table.entity')}</th>
            <th>{t('common:table.status')}</th>
            <th>{t('table.cap')}</th>
            <th>{t('common:table.created')}</th>
            <th>{t('common:table.finished')}</th>
            <th>{t('common:table.stats')}</th>
          </BrutTheadRow>
          <tbody>
            {jobs.map((job) => (
              <tr key={job.id} className="bo-row--link" onClick={() => void navigate(`/crm-data/jobs/${job.id}`)}>
                <td className="bo-cell-muted">{job.id}</td>
                <td>
                  <ModeBadge mode={job.mode} />
                </td>
                <td>
                  <EntityBadge entityType={job.entityType} />
                </td>
                <td>
                  <StatusBadge status={job.status} />
                </td>
                <td>{job.cap ?? '—'}</td>
                <td>
                  <RelativeTime value={job.createdAt} />
                </td>
                <td>
                  <RelativeTime value={job.finishedAt} />
                </td>
                <td className="bo-cell-note">
                  <span className="bo-clip" title={prettyJson(job.stats)}>
                    {statsSummary(job.stats)}
                  </span>
                </td>
              </tr>
            ))}
            {!isLoading && jobs.length === 0 && (
              <tr>
                <td colSpan={8} className="bo-cell-empty">
                  {t('table.empty')}
                </td>
              </tr>
            )}
            {isLoading && (
              <tr>
                <td colSpan={8} className="bo-cell-empty">
                  {t('common:actions.loading')}
                </td>
              </tr>
            )}
          </tbody>
        </BrutTable>
      </TableScroll>
    </section>
  );
}
